import React, { useState, useEffect, useRef } from "react";
import Message from "../../utils/modals/Message";
import Cards from "../../dynamic-components/Cards";
import UsersTable from "./UsersTable";
import CreateUserModal from "../../utils/modals/office-modal/CreateUserModal";
// import ChargeWalletModal from "../../utils/modals/wallet-tab/charge-wallet/ChargeWalletModal";
// import { getWalletCardsSetData } from "../../../context/api/cards/wallet-tab/getWalletCardsSetData";
import { getOfficeTableSetData } from "../../../context/api/tables/office/getOfficeTableSetData";
import { officeSwitcher_1 } from "../../utils/extra/cards/swichers";
import Spinner from "react-bootstrap/Spinner";
import { useCookies } from "react-cookie";

const Index = ({ lang }) => {
  const [cookies] = useCookies();

  const dataTranslate = require(`../../../translate/${
    lang === "AR" ? "arabic" : "english"
  }/data.json`);

  const initialMessageRes = {
    success: Boolean,
    message: String,
    isShow: false,
  };
  const initialCreateUserModal = {
    isShow: false,
    rowData: {},
  };

  const cards = [
    {
      all: "",
    },
    {
      blocked: "",
    },
  ];

  const fetched = useRef(false);
  const cardAction = useRef();
  const [activeCard, setActiveCard] = useState("all");
  const [messageResponse, setMessageResponse] = useState(initialMessageRes);
  const [cardsData, setCardsData] = useState(cards);
  const [tableData, setTableData] = useState([]);
  const [tableLoader, setTableLoader] = useState(true);
  // modals
  const [createUserModal, setCreateUserModal] = useState(
    initialCreateUserModal
  );
  const [refreshData, setRefreshData] = useState(0);

  const fetchOnStart = async () => {
    fetched.current = false;

    // await getWalletCardsSetData(
    //   lang,
    //   setMessageResponse,
    //   cookies,
    //   setCardsData,
    //   userId
    // );
    await getOfficeTableSetData(
      lang,
      setMessageResponse,
      cookies,
      activeCard,
      setTableData,
      setTableLoader
    );

    fetched.current = true;
  };

  useEffect(() => {
    fetchOnStart();
  }, [refreshData]);

  if (!fetched.current) {
    return (
      <div className="page_loader">
        <Spinner animation="border" variant="warning" />
      </div>
    );
  }

  const fetchTableData = async (key) => {
    setTableLoader(() => true);
    if (key) {
      cardAction.current = key;
    }

    await getOfficeTableSetData(
      lang,
      setMessageResponse,
      cookies,
      cardAction.current,
      setTableData,
      setTableLoader
    );
  };

  const dataCard1 = cardsData;

  return (
    <>
      <Message
        messageResponse={messageResponse}
        close={() => setMessageResponse(initialMessageRes)}
        lang={lang}
      />

      <CreateUserModal
        show={createUserModal.isShow}
        onHide={() => setCreateUserModal(initialCreateUserModal)}
        lang={lang}
        dataTranslate={dataTranslate}
        setRefreshData={setRefreshData}
      />

      <div className="office_p" dir={lang === "AR" ? "rtl" : "ltr"}>
        <Cards
          pageClass="office_p"
          lang={lang}
          dataCard1={dataCard1}
          switcher_1={officeSwitcher_1}
          activeCard={activeCard}
          setActiveCard={setActiveCard}
          fetchTableData={fetchTableData}
        />
        <UsersTable
          lang={lang}
          loader={tableLoader}
          setRefreshData={setRefreshData}
          tableData={tableData.length > 0 ? tableData : ""}
          setCreateUserModal={setCreateUserModal}
          activeCard={activeCard}
        />
      </div>
    </>
  );
};

export default Index;
